import React from 'react';
import { cn } from '../../../lib/cn';

/**
 * Radio, the 22px circle that means single-select.
 *
 * CSS selector: `mobile/atoms.css` `.ds-radio` (+ `--checked` for the
 * span-based fallback, which this component does not need).
 *
 * Doctrine: accent marks selection state, so the checked dot is accent, not
 * ink. Ink is reserved for commands. Built on a real `<input type="radio">` so
 * form semantics and keyboard behaviour come for free, never a styled div.
 *
 * The control stays exactly 22px on purpose. The 44px tap target belongs to the
 * row around it, so always wrap this in `<OptionRow>` or an equivalent padded
 * label rather than inflating the control itself.
 */
export const Radio = React.forwardRef(function Radio(
  { className, type = 'radio', ...rest },
  ref,
) {
  return <input ref={ref} type={type} className={cn('ds-radio', className)} {...rest} />;
});

export default Radio;
